import { Pipe, PipeTransform } from '@angular/core';
import { CheckboxFilter, Filter, FilterTypes } from '@models/filter-types';

@Pipe({
    name: 'isCheckboxFilter',
    standalone: false,
})
export class IsCheckboxFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is CheckboxFilter<unknown> {
        return value?.Type === FilterTypes.CheckboxFilterType;
    }
}
